
export const MOCK_RESULTS = {
  resume_data: {
    name: "John Doe",
    contact_info: "john.doe@example.com | 123-456-7890 | San Francisco, CA",
    summary: "Experienced software engineer with a focus on full-stack development. Proven track record of delivering high-quality software solutions.",
    skills: ["React", "Node.js", "TypeScript", "Python", "AWS", "Docker"],
    experience: [
      {
        title: "Senior Software Engineer",
        company: "Tech Corp",
        duration: "Jan 2020 - Present",
        bullets: [
            "Led a team of 5 engineers to develop a new e-commerce platform.",
            "Improved system performance by 30% through code optimization.",
            "Implemented CI/CD pipelines to automate deployment processes."
        ]
      },
      {
        title: "Software Engineer",
        company: "Startup Inc",
        duration: "Jun 2018 - Dec 2019",
        bullets: [
            "Developed front-end components using React and Redux.",
            "Collaborated with designers to implement user-friendly interfaces.",
            "Participated in code reviews and provided constructive feedback."
        ]
      }
    ],
    education: [
      {
        institution: "University of Tech",
        degree: "Bachelor of Science in Computer Science",
        year: "2018"
      }
    ]
  },
  cover_letter_text: "Dear Hiring Manager,\n\nI am writing to express my interest in the Software Engineer position at [Company Name]. With my background in...",
  resume_pdf_url: "#",
  cover_letter_pdf_url: "#",
  scores: {
      before: { total_score: 65 },
      after: { 
          total_score: 85,
          breakdown: {
              missing_keywords: ["Kubernetes", "GraphQL"]
          }
      }
  },
  diff: {},
  original_text: ""
};
